import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_PSF_REASON_FOR_SIGNING = createFcmConfig('psf_reason_for_signing', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
